import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const NewsNotification = () => {
  const history = useHistory();

  const onMessage = (message: any) => {
    let data = message.data;

    try {
      data = typeof data === 'string' ? JSON.parse(data) : data;
      if (data?.contentId) {
        history.push(`/news/${data.contentId}`);
      }
    } catch (e) {
      console.error('Error: ', e);
    }
  };

  useEffect(() => {
    // Add the event listener for messages passed from app wrapper
    document.addEventListener('message', onMessage);
    window.addEventListener('message', onMessage);

    // To prevent memory leaks, remove all event listeners on demount
    return () => {
      document.removeEventListener('message', onMessage);
      window.removeEventListener('message', onMessage);
    };
  }, []);

  return null;
};

export default NewsNotification;
